<script>
    import StripeForm from './StripeForm.vue'

    export default {
        components: {StripeForm},
        methods: {
            onSubmit() {
                this.$refs
                    .newCard
                    .onSubmit()
                    .then(({token}) => {
                        let data = {
                            brand: token.card.brand,
                            last4: token.card.last4
                        }
                        this.$emit('update-form-data', {data})
                        this.$emit('reset-sub-tab')
                    })
                    .catch(error => {
                        window.alerts.error("Si è verificato un errore, riprova")
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/cart/StripeCardForm.vue